import { FeatureFlagsDef } from './flagsConstants';
import { type TFeatFlagsState, FeatFlag } from './flagTypes';

// module state
const state: TFeatFlagsState = {
  depthPeelingLayers: FeatureFlagsDef.depthPeelingLayers,
  disableTransparencyAngleBasedCompensation:
    FeatureFlagsDef.disableTransparencyAngleBasedCompensation,
  disableTransparencyFlatCompensation: FeatureFlagsDef.disableTransparencyFlatCompensation,
  mipMapsGaussianBlur: FeatureFlagsDef.mipMapsGaussianBlur,
  parallax: FeatureFlagsDef.parallax,
  premultipliedAlphaLogos: FeatureFlagsDef.premultipliedAlphaLogos,
  wireframeFabrics: FeatureFlagsDef.wireframeFabrics,
};

/**
 * Is flag enabled.
 * @param flag - Feature.
 */
export const isEnabled = (flag: FeatFlag): boolean => {
  switch (flag) {
    case FeatFlag.DEPTH_PEELING:
      return state.depthPeelingLayers > 0;
    case FeatFlag.DISABLE_TRANSPARENCY_ANGLE_BASED_COMPENSATION:
      return state.disableTransparencyAngleBasedCompensation;
    case FeatFlag.DISABLE_TRANSPARENCY_FLAT_COMPENSATION:
      return state.disableTransparencyFlatCompensation;
    case FeatFlag.MIPMAPS_GAUSSIAN_BLUR:
      return state.mipMapsGaussianBlur;
    case FeatFlag.PARALLAX:
      return state.parallax;
    case FeatFlag.PREMULTIPLIED_ALPHA_LOGOS:
      return Boolean(state.premultipliedAlphaLogos);
    case FeatFlag.WIREFRAME_FABRICS:
      return state.wireframeFabrics;
    default:
      return false;
  }
};

/**
 * Get flags state.
 */
export const getState = (): TFeatFlagsState => {
  return state;
};

/**
 * Set flags state.
 * @param newState - New state.
 */
export const setState = (newState: TFeatFlagsState) => {
  state.depthPeelingLayers = newState.depthPeelingLayers;
  state.disableTransparencyAngleBasedCompensation =
    newState.disableTransparencyAngleBasedCompensation;
  state.disableTransparencyFlatCompensation = newState.disableTransparencyFlatCompensation;
  state.mipMapsGaussianBlur = newState.mipMapsGaussianBlur;
  state.parallax = newState.parallax;
  state.premultipliedAlphaLogos = newState.premultipliedAlphaLogos;
  state.wireframeFabrics = newState.wireframeFabrics;
};

/**
 * Get flag value.
 * @param flag - Feature.
 */
export const getValue = (flag: FeatFlag): any => {
  switch (flag) {
    case FeatFlag.DEPTH_PEELING:
      return state.depthPeelingLayers;
    default:
      return false;
  }
};
